const programSettingsFormMixin = {
  data() {
    return {
      disableSave: true
    };
  },

  methods: {
    isOriginalValue(key, value) {
      return this.$store.getters["program/coreProgramMeta"][key] === value;
    }
  }
};

export default programSettingsFormMixin;
